export default __webpack_public_path__ + "static/media/miguel-lopes-41.1b2b8f23.jpg";